import { AxiosPromise } from 'axios';
import { apiInstance as instance } from '.';
import { LogTrace } from '../sic-lib/types/Logging';

export function logTrace(data: LogTrace, signal?: AbortSignal): AxiosPromise<string> {
    return instance.post('/log/trace', data, { signal });
}
